// extracted by mini-css-extract-plugin
export default {"PageContainerMain":"Page_PageContainerMain__En7YU","PageContainer":"Page_PageContainer__C-Mal"};